<template>
  <v-row>
    <template v-if="isGenerated">
      <v-col
        cols="12"
        md="12"
      >
        <v-col cols="12">
          <v-autocomplete
            v-model="form.type"
            :items="types"
            outlined
            label="Pending Bills Looking For "
            @change="reset"
          />
        </v-col>
        <template v-if="form.type === 'Customers'">
          <v-col cols="12">
            <v-autocomplete
              v-model="form.customer"
              :items="customers"
              item-text="firstName"
              return-object
              outlined
              label="Select Customer"
            />
          </v-col>
        </template>
        <template v-if="form.type === 'Suppliers'">
          <v-col cols="12">
            <v-autocomplete
              v-model="form.supplier"
              :items="suppliers"
              item-text="firstName"
              return-object
              outlined
              label="Select Supplier"
            />
          </v-col>
        </template>
        <v-col cols="12">
          <v-btn
            :disabled="preCheck"
            @click="loadPayments"
          >
            Calculate
          </v-btn>
        </v-col>
      </v-col>
    </template>
    <template v-else>
      <v-col
        cols="12"
        md="12"
      >
        <div class="d-print-none text-right">
          <v-btn @click="printBillReport">
            Print
          </v-btn>
          <v-btn @click="backNow">
            Clear
          </v-btn>
        </div>
        <div class="">
          <h3>PENDING BILLS REPORT</h3>
          <h4>Generated At : {{ reference.time }}</h4>
          <h4>Generated By : {{ reference.by }}</h4>
          <img
            :src="reference.barcode"
            class="white pa-1"
          >
        </div>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  TRX
                </th>
                <th>Person Name</th>
                <th>Date</th>
                <th>Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="payment in payments.list"
                :key="payment.id"
              >
                <td>
                  <img
                    :src="payment.order.barcode"
                    class="payKey"
                  >
                </td>
                <td>
                  <template v-if="form.type === 'Customers'">
                    {{ form.customer.firstName }}
                  </template>
                  <template v-else>
                    {{ form.supplier.firstName }}
                  </template>
                </td>
                <td>{{ payment.created_at }}</td>
                <td>{{ payment.type ? "Credit" : "Debit" }}</td>
                <td>{{ payment.amount | currency }}</td>
              </tr>

              <tr>
                <td
                  colspan="4"
                  class="text-right"
                >
                  Total Credit Amount
                </td>
                <td>{{ payments.creditAmount | currency }}</td>
              </tr>
              <tr>
                <td
                  colspan="4"
                  class="text-right"
                >
                  Total Debit Amount
                </td>
                <td>{{ payments.debitAmount | currency }}</td>
              </tr>
              <tr class="active">
                <th
                  colspan="4"
                  class="text-right"
                >
                  Total Payable Amount ( {{ payments.unPaid }} )
                </th>
                <td>{{ payments.unPaidAmount | currency }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      isGenerated: true,
      reference: {},
      payments: {
        unPaid: 0,
        unPaidAmount: 0,
      },
      customers: [],
      suppliers: [],
      types: ["Customers", "Suppliers"],
      form: {
        supplier_id: null,
        customer_id: null,
      },
    };
  },
  computed: {
    preCheck() {
      const form = this.$data.form;
      if ((form.type && form.customer) || form.supplier) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.getFromApi();
  },
  methods: {
    backNow() {
      this.reset();
      Event.$emit("showDrawer");
      this.$data.isGenerated = true;
    },
    printBillReport() {
      Event.$emit("hideDrawer");
      setTimeout(() => {
        window.print();
      }, 350);
    },
    loadPayments() {
      const info = this.$data.form;
      if (info.type === "Customers") {
        this.$data.form.customer_id = info.customer.id;
      }
      if (info.type === "Suppliers") {
        this.$data.form.supplier_id = info.supplier.id;
      }
      window.axios.post("/pending-bill", this.$data.form).then((response) => {
        this.$data.payments = response.data;
        this.$data.reference = response.data.ref;
        this.isGenerated = false;
        this.printBillReport();
      });
    },
    reset() {
      this.$data.customer = null;
      this.$data.form.customer_id = null;
      this.$data.supplier = null;
      this.$data.form.supplier_id = null;
    },
    getFromApi() {
      window.axios.get("/product-form-data").then((response) => {
        this.customers = response.data.customers;
        this.suppliers = response.data.suppliers;
      });
    },
  },
};
</script>
<style type="text/css">
.payKey {
  width: 100px;
  height: 15px;
}
</style>
